export class RequestError extends Error {
    constructor(public readonly value: any) {
        const message = typeof value === 'string' ? value : JSON.stringify(value);
        super(message);
    }
}
